(function () {
  // Mobile nav
  var nav = document.getElementById('siteNav');
  document.querySelectorAll('[data-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () { nav && nav.classList.add('is-open'); });
  });
  if (nav) {
    nav.addEventListener('click', function (e) {
      if (e.target === nav || e.target.closest('[data-nav-close]') || e.target.closest('a')) nav.classList.remove('is-open');
    });
  }

  // Gallery: arrows, dots, thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var dots = g.querySelectorAll('.gallery__dot');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    g.querySelector('.gallery-arrow--prev') && g.querySelector('.gallery-arrow--prev').addEventListener('click', function () { show(i - 1); });
    g.querySelector('.gallery-arrow--next') && g.querySelector('.gallery-arrow--next').addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var x0 = null;
    var main = g.querySelector('.gallery__main');
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
  });

  // Every "buy" link goes straight to checkout with exactly one unit (cart permalink).
  // Header CTA and final CTA point to #buy by default; rewrite them to the same permalink
  // so a click anywhere on the page lands in checkout, not on the form.
  var primaryBuy = document.querySelector('[data-buy-link]');
  if (primaryBuy) {
    document.querySelectorAll('a[href="#buy"], a[href$="/#buy"]').forEach(function (a) {
      a.href = primaryBuy.href;
      a.setAttribute('data-buy-link', '');
    });
  }

  // Bundle selector -> variant id + price card + sticky bar + buy links
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var idInput = form.querySelector('input[name="id"]');
    var cards = form.querySelectorAll('.bundle-card');
    function apply(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      idInput.value = card.dataset.variantId;
      if (card.dataset.buyUrl) {
        document.querySelectorAll('[data-buy-link]').forEach(function (a) { a.href = card.dataset.buyUrl; });
      }
      var root = form.closest('[data-product-root]');
      var set = function (sel, val, hide) {
        (root || document).querySelectorAll(sel).forEach(function (el) {
          el.textContent = val;
          if (hide !== undefined) el.hidden = hide;
        });
      };
      var noSale = !card.dataset.compare;
      set('[data-price]', card.dataset.price);
      set('[data-compare]', card.dataset.compare || '', noSale);
      set('[data-save]', card.dataset.save || '', noSale);
      set('[data-save-percent]', card.dataset.savePercent || '', noSale);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = card.dataset.available !== 'true';
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () { apply(c); });
    });
  });

  // Sticky panel + back to top appear after the buy button leaves the viewport
  var buy = document.getElementById('buy-button');
  var panel = document.querySelector('.bottom-panel');
  var top = document.querySelector('.back-to-top');
  function onScroll() {
    var past = buy ? buy.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    panel && panel.classList.toggle('is-visible', past);
    top && top.classList.toggle('is-visible', window.scrollY > 800);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  top && top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();

/* Option pickers (apparel product) + autoplay helper */
(function () {
  document.querySelectorAll('[data-option-picker]').forEach(function (root) {
    var data = root.querySelector('[data-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-input]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var cartUrl = (root.querySelector('[data-buy-link]') || {}).href || '';
    cartUrl = cartUrl.replace(/\/\d+:\d+.*$/, '');
    function selected() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function matches(v, sel, skip) {
      return v.o.every(function (x, i) { return i === skip || sel[i] === null || x === sel[i]; });
    }
    function setText(sel, val, hide) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; if (hide !== undefined) el.hidden = hide; });
    }
    function apply() {
      var sel = selected();
      var v = variants.filter(function (x) { return matches(x, sel); })[0];
      groups.forEach(function (g, gi) {
        var lab = g.querySelector('[data-option-selected]');
        if (lab && sel[gi] !== null) lab.textContent = sel[gi];
        g.querySelectorAll('.opt__value').forEach(function (w) {
          var inp = w.querySelector('input');
          var ok = variants.some(function (x) { return x.a && x.o[gi] === inp.value && matches(x, sel, gi); });
          w.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var href = cartUrl + '/' + v.id + ':1';
      document.querySelectorAll('[data-buy-link]').forEach(function (a) { a.href = href; });
      setText('[data-price]', v.p);
      setText('[data-compare]', v.c || '', !v.c);
      setText('[data-save]', v.c ? ((root.dataset.saveLabel || '') + ' ' + v.pct + '%').trim() : '', !v.c);
      setText('[data-save-percent]', v.c ? '-' + v.pct + '%' : '', !v.c);
      var btn = root.querySelector('#buy-button');
      if (btn) {
        btn.classList.toggle('is-disabled', !v.a);
        btn.textContent = v.a ? btn.dataset.ctaLabel : btn.dataset.soldOutLabel;
      }
    }
    var saveEl = root.querySelector('[data-save]');
    if (saveEl && saveEl.textContent) root.dataset.saveLabel = saveEl.textContent.replace(/\s*\d+%\s*$/, '');
    groups.forEach(function (g) { g.addEventListener('change', apply); });
    apply();
  });

  document.querySelectorAll('video[data-autoplay]').forEach(function (v) {
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  });
})();
